import '../../App.css'
import { useContext, useEffect, useState } from 'react'
import Aside from '../../component/aside'
import { useNavigate, useParams } from 'react-router-dom'
import Navbar from '../../component/navbar'
import Loading from '../../component/loading'
import { hourToSecend } from '../../component/hourToSecend'
import RequestQueue from '../../api/requestQueue'
import { toast } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faBuilding,
    faCalendarCheck,
    faChevronDown,
    faClock,
    faLock,
    faLightbulb,
    faMessage,
    faPhone,
    faSave,
    faTimes,
    faUser,
    faUserEdit,
    faUserSecret,
} from '@fortawesome/free-solid-svg-icons'
import { secendToHour } from '../../component/secendToHour'
import { AppContextMenu } from '../../App'

function UserEdit() {
    const { updateValue } = useContext(AppContextMenu)
    useEffect(() => {
        updateValue('users')
    }, [])

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!JSON.parse(localStorage.getItem('authResult'))) {
            navigate('/login')
        }
    }, [])
    const [roleData, setRoleData] = useState([])
    const [addData, setAddData] = useState({
        is_anonymous_message: 'false',
    })
    const [departmentData, setDepartmentData] = useState([])
    const [positionData, setPositionData] = useState([])
    const [departmentSearch, setDepartmentSearch] = useState(null)
    const [positionSearch, setPositionSearch] = useState(null)
    const [shiftData, setShiftData] = useState([])

    let navigate = useNavigate()

    const { id } = useParams()

    useEffect(() => {
        getUser()
        getRole()
    }, [])

    const getRole = async () => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/role`,
            },
            resolve: (res) => {
                setRoleData(res.data)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const getDepartment = async (selectOrganizationId) => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/department/${selectOrganizationId}`,
            },
            resolve: (res) => {
                setDepartmentData(res.data)
                handlerShift(selectOrganizationId)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
            },
        })
    }

    const handlerShift = async (organizations_id) => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/shift/organization/${organizations_id}`,
            },
            resolve: (res) => {
                setShiftData(res.data)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
            },
        })
    }

    const getUser = async () => {
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/user/${id}`,
            },
            resolve: (res) => {
                let resDataUser = res.data

                setAddData(resDataUser)

                setDepartmentSearch(
                    resDataUser.userDepartmentPosition[0]?.department_id
                )
                setPositionSearch(
                    resDataUser.userDepartmentPosition[0]?.position_id
                )
                getDepartment(resDataUser.organization_id)
                getPosition(
                    resDataUser.userDepartmentPosition[0]?.department_id
                )
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const getPosition = async (id) => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/position/department/${id}`,
            },
            resolve: (res) => {
                setPositionData(res.data)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
            },
        })
    }

    const setQueryPropertyAddData = (key, e) => {
        switch (key) {
            case 'full_name':
                setAddData({ ...addData, full_name: e.target.value })
                break
            case 'emergency_number':
                setAddData({ ...addData, emergency_number: e.target.value })
                break
            case 'address':
                setAddData({ ...addData, address: e.target.value })
                break
            case 'phone_number':
                setAddData({ ...addData, phone_number: e.target.value })
                break
            case 'personnel_code':
                setAddData({ ...addData, personnel_code: e.target.value })
                break
            case 'password':
                setAddData({ ...addData, password: e.target.value })
                break
            case 'role_id':
                setAddData({ ...addData, role_id: e.target.value })
                break
            case 'shift_id':
                setAddData({ ...addData, shift_id: e.target.value })
                break
            case 'is_anonymous_message':
                setAddData({ ...addData, is_anonymous_message: e.target.value })
                break
            case 'is_ideas_viewer':
                setAddData({ ...addData, is_ideas_viewer: e.target.value })
                break
            case 'entitlement_hours':
                const value = hourToSecend(e.target.value)
                setAddData({ ...addData, entitlement_hours: value })
                break
            default:
                return null
        }
    }

    const handlerSubmit = async () => {
        console.log(addData, 'addData')
        setLoading(true)

        let departmentPositionValues = null

        if (departmentSearch && positionSearch) {
            departmentPositionValues = {
                department_id: departmentSearch,
                position_id: positionSearch,
            }
        }

        await RequestQueue.sendRequest({
            config: {
                method: 'patch',
                url: `/user/${id}`,
                data: {
                    departmentsPositions: departmentPositionValues,
                    full_name: addData.full_name,
                    phone_number: addData.phone_number,
                    password: addData.password,
                    personnel_code: addData.personnel_code,
                    entitlement_hours: addData.entitlement_hours,
                    emergency_number: addData.emergency_number,
                    address: addData.address,
                    is_anonymous_message:
                        addData.is_anonymous_message === 'true' ||
                        addData.is_anonymous_message === true,
                    is_ideas_viewer:
                        addData.is_ideas_viewer === 'true' ||
                        addData.is_ideas_viewer === true,
                    role_id: addData.role_id,
                    shift_id: addData.shift_id,
                },
            },
            resolve: (res) => {
                setLoading(false)
                toast.dismiss()
                toast.success('کاربر با موفقیت ویرایش شد', {
                    position: 'bottom-center',
                })
                navigate('/users')
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                })
            },
        })
    }
    const handlerCancel = () => {
        navigate(-1)
    }

    console.log(addData, 'departmentSearch')
    return (
        <>
            {loading ? <Loading /> : null}
            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />

                    <div className="bg-white rounded-xl shadow-lg  border border-gray-200 mx-4 my-6">
                        {/* Header */}
                        <div className="px-6 py-5 border-b border-gray-200 bg-gradient-to-r from-indigo-600 to-purple-600">
                            <h2 className="text-2xl font-bold text-white">
                                <FontAwesomeIcon
                                    icon={faUserEdit}
                                    className="ml-2"
                                />
                                ویرایش کاربر
                            </h2>
                        </div>

                        {/* Form Content */}
                        <div className="p-6 space-y-6">
                            {/* Full Name */}
                            <div className="space-y-2">
                                <label className="block text-sm font-medium text-gray-700 flex items-center">
                                    <FontAwesomeIcon
                                        icon={faUser}
                                        className="ml-2"
                                    />
                                    نام و نام خانوادگی
                                </label>
                                <input
                                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                    type="text"
                                    value={addData.full_name}
                                    onChange={(e) => {
                                        setQueryPropertyAddData('full_name', e)
                                    }}
                                />
                            </div>

                            {/* Phone Number */}
                            <div className="space-y-2">
                                <label className="block text-sm font-medium text-gray-700 flex items-center">
                                    <FontAwesomeIcon
                                        icon={faPhone}
                                        className="ml-2"
                                    />
                                    شماره همراه
                                </label>
                                <input
                                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                    type="tel"
                                    value={addData.phone_number}
                                    onChange={(e) => {
                                        setQueryPropertyAddData(
                                            'phone_number',
                                            e
                                        )
                                    }}
                                />
                            </div>

                            {/* Password */}
                            <div className="space-y-2">
                                <label className="block text-sm font-medium text-gray-700 flex items-center">
                                    <FontAwesomeIcon
                                        icon={faLock}
                                        className="ml-2"
                                    />
                                    رمز عبور
                                </label>
                                <input
                                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                    type="text"
                                    value={addData.password}
                                    onChange={(e) => {
                                        setQueryPropertyAddData('password', e)
                                    }}
                                />
                            </div>

                            {/* Entitlement Hours */}
                            <div className="space-y-2">
                                <label className="block text-sm font-medium text-gray-700 flex items-center">
                                    <FontAwesomeIcon
                                        icon={faClock}
                                        className="ml-2"
                                    />
                                    مرخصی استحقاقی
                                </label>
                                <input
                                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                    type="tel"
                                    value={secendToHour(
                                        addData.entitlement_hours
                                    )}
                                    onChange={(e) => {
                                        setQueryPropertyAddData(
                                            'entitlement_hours',
                                            e
                                        )
                                    }}
                                />
                            </div>
                            <div className="space-y-2">
                                <label className=" text-sm font-medium text-gray-700 flex items-center">
                                    <FontAwesomeIcon
                                        icon={faMessage}
                                        className="ml-2"
                                    />
                                    دسترسی به پیام های ناشناس
                                </label>
                                <select
                                    className="w-full px-4 py-3 border bg-white border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                    onChange={(e) => {
                                        setQueryPropertyAddData(
                                            'is_anonymous_message',
                                            e
                                        )
                                    }}
                                >
                                    {addData.is_anonymous_message ||
                                    addData.is_anonymous_message === 'true' ? (
                                        <option value="true" selected>
                                            دارد
                                        </option>
                                    ) : (
                                        <option value="true">دارد</option>
                                    )}
                                    {addData.is_anonymous_message ||
                                    addData.is_anonymous_message === 'false' ? (
                                        <option value="false">ندارد</option>
                                    ) : (
                                        <option value="false" selected>
                                            ندارد
                                        </option>
                                    )}
                                </select>
                            </div>
                            <div className="space-y-2">
                                <label className=" text-sm font-medium text-gray-700 flex items-center">
                                    <FontAwesomeIcon
                                        icon={faLightbulb}
                                        className="ml-2"
                                    />
                                    دسترسی به ایده‌های ثبت‌شده
                                </label>
                                <select
                                    className="w-full px-4 py-3 border bg-white border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                    onChange={(e) => {
                                        setQueryPropertyAddData(
                                            'is_ideas_viewer',
                                            e
                                        )
                                    }}
                                    value={
                                        addData.is_ideas_viewer === true ||
                                        addData.is_ideas_viewer === 'true'
                                            ? 'true'
                                            : 'false'
                                    }
                                >
                                    <option value="true">دارد</option>
                                    <option value="false">ندارد</option>
                                </select>
                            </div>
                            <div className="space-y-2">
                                <label className=" text-sm font-medium text-gray-700 flex items-center">
                                    <FontAwesomeIcon
                                        icon={faCalendarCheck}
                                        className="ml-2"
                                    />
                                    شیفت
                                </label>
                                <select
                                    className="w-full px-4 py-3 border bg-white border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                    onChange={(e) => {
                                        setQueryPropertyAddData('shift_id', e)
                                    }}
                                >
                                    <option value={''}>انتخاب کنید</option>
                                    {shiftData.map((item) => {
                                        return (
                                            <>
                                                <option
                                                    value={item.id}
                                                    selected={
                                                        item.id ===
                                                        addData.shift_id
                                                    }
                                                >
                                                    {item.name}
                                                </option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className="space-y-2">
                                <label className=" text-sm font-medium text-gray-700 flex items-center">
                                    <FontAwesomeIcon
                                        icon={faUserSecret}
                                        className="ml-2"
                                    />
                                    نقش
                                </label>
                                <select
                                    className="w-full px-4 py-3 border bg-white border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                    onChange={(e) => {
                                        setQueryPropertyAddData('role_id', e)
                                    }}
                                >
                                    <option value={''}>انتخاب کنید</option>
                                    {roleData.map((item) => {
                                        return (
                                            <>
                                                {item?.name === 'superAdmin' &&
                                                RequestQueue.getAuthResult()
                                                    ?.user?.role?.name ===
                                                    'superAdmin' ? (
                                                    <option
                                                        value={item.id}
                                                        selected={
                                                            item.id ===
                                                            addData.role_id
                                                        }
                                                    >
                                                        {item.nick_name}
                                                    </option>
                                                ) : (
                                                    ''
                                                )}

                                                {item?.name !== 'superAdmin' ? (
                                                    <option
                                                        value={item.id}
                                                        selected={
                                                            item.id ===
                                                            addData.role_id
                                                        }
                                                    >
                                                        {item.nick_name}
                                                    </option>
                                                ) : (
                                                    ''
                                                )}
                                            </>
                                        )
                                    })}
                                </select>
                            </div>
                            {/* Optional Fields */}
                            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                                <h4 className="text-sm font-medium text-gray-700 mb-3">
                                    اطلاعات اختیاری
                                </h4>

                                {/* Personnel Code */}
                                <div className="space-y-2 mb-4">
                                    <label className="block text-sm font-medium text-gray-700">
                                        کد پرسنلی
                                    </label>
                                    <input
                                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        type="text"
                                        value={addData.personnel_code}
                                        onChange={(e) => {
                                            setQueryPropertyAddData(
                                                'personnel_code',
                                                e
                                            )
                                        }}
                                    />
                                </div>

                                {/* Emergency Number */}
                                <div className="space-y-2 mb-4">
                                    <label className="block text-sm font-medium text-gray-700">
                                        شماره همراه اضطراری
                                    </label>
                                    <input
                                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        type="tel"
                                        value={addData.emergency_number}
                                        onChange={(e) => {
                                            setQueryPropertyAddData(
                                                'emergency_number',
                                                e
                                            )
                                        }}
                                    />
                                </div>

                                {/* Address */}
                                <div className="space-y-2">
                                    <label className="block text-sm font-medium text-gray-700">
                                        آدرس
                                    </label>
                                    <input
                                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        type="text"
                                        value={addData.address}
                                        onChange={(e) => {
                                            setQueryPropertyAddData(
                                                'address',
                                                e
                                            )
                                        }}
                                    />
                                </div>
                            </div>

                            {/* Department & Position */}
                            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                                <h4 className="text-sm font-medium text-gray-700 mb-3">
                                    بخش کاری و جایگاه شغلی
                                </h4>

                                <div className="flex flex-col items-end md:flex-row gap-4">
                                    {/* Department */}
                                    <div className="flex-1 space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            بخش کاری
                                        </label>
                                        <div className="relative">
                                            <select
                                                id="substitutePersonId"
                                                className="w-full px-4 py-3 border bg-white border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 appearance-none"
                                                name="substitutePersonId"
                                                onChange={(e) => {
                                                    setDepartmentSearch(
                                                        e.target.value
                                                    )
                                                    getPosition(e.target.value)
                                                }}
                                            >
                                                <option value="none" selected>
                                                    انتخاب کنید
                                                </option>
                                                {departmentData.map((d) => {
                                                    return (
                                                        <option
                                                            value={d.id}
                                                            selected={
                                                                d.id ===
                                                                departmentSearch
                                                            }
                                                        >
                                                            {d.name}
                                                        </option>
                                                    )
                                                })}
                                            </select>
                                            <FontAwesomeIcon
                                                icon={faChevronDown}
                                                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                                            />
                                        </div>
                                    </div>

                                    {/* Position */}
                                    <div className="flex-1 space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            جایگاه شغلی
                                        </label>
                                        <div className="relative">
                                            <select
                                                id="substitutePersonId"
                                                className="w-full px-4 py-3 border bg-white border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 appearance-none"
                                                name="substitutePersonId"
                                                onChange={(e) => {
                                                    setPositionSearch(
                                                        e.target.value
                                                    )
                                                }}
                                            >
                                                <option value="">
                                                    انتخاب کنید
                                                </option>
                                                {positionData.map((d) => {
                                                    return (
                                                        <option
                                                            value={d.id}
                                                            selected={
                                                                d.id ===
                                                                positionSearch
                                                            }
                                                        >
                                                            {d.name}
                                                        </option>
                                                    )
                                                })}
                                            </select>
                                            <FontAwesomeIcon
                                                icon={faChevronDown}
                                                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Form Actions */}
                            <div className="flex justify-end space-x-3 space-x-reverse pt-6 maxLg:flex-col">
                                <button
                                    type="button"
                                    onClick={handlerCancel}
                                    className="px-6 py-3 maxLg:my-2 border border-gray-300 rounded-xl text-gray-700 bg-white hover:bg-gray-50 transition-colors flex items-center"
                                >
                                    <FontAwesomeIcon
                                        icon={faTimes}
                                        className="ml-2"
                                    />
                                    انصراف
                                </button>
                                <button
                                    type="button"
                                    onClick={handlerSubmit}
                                    className="px-6 py-3 maxLg:my-2 rounded-xl text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all shadow-md hover:shadow-lg flex items-center"
                                >
                                    <FontAwesomeIcon
                                        icon={faSave}
                                        className="ml-2"
                                    />
                                    ذخیره تغییرات
                                </button>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default UserEdit
